import cn from "classnames";
import { BackgroundGradientClassName } from "@/constants/style";
import { GradientVariant } from "@/constants/theme";

export function getBackgroundGradientClassName(gradient: GradientVariant) {
  return cn({
    [BackgroundGradientClassName.GRADIENT_1]:
      gradient === GradientVariant.Gradient1,
    [BackgroundGradientClassName.GRADIENT_2]:
      gradient === GradientVariant.Gradient2,
    [BackgroundGradientClassName.GRADIENT_3]:
      gradient === GradientVariant.Gradient3,
    [BackgroundGradientClassName.GRADIENT_4]:
      gradient === GradientVariant.Gradient4,
  });
}
